// extracted by mini-css-extract-plugin
export default {"SearchResList":"SearchResList_SearchResList__RUntK"};